import {Component} from 'react'

import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from 'react-icons/md'
import './index.css'
import MoodTrackerContext from '../../context/MoodTrackerContext'

class Calendar extends Component {
  render() {
    return (
      <MoodTrackerContext.Consumer>
        {value => {
          const {
            calenderList,
            onChangeCalenderList,
            onRightArrowClick,
            onLeftArrowClick,
            daysList,
            month,
          } = value

          return (
            <>
              <div className="arrow-container">
                <button
                  type="button"
                  onClick={onLeftArrowClick}
                  className="arrow-button"
                  aria-label="Previous"
                  data-testid="previous-button"
                >
                  <MdOutlineKeyboardArrowLeft className="arrow-icon" />
                </button>

                <h1 className="month-para">
                  {calenderList[month - 1].monthName}
                </h1>

                <button
                  type="button"
                  onClick={onRightArrowClick}
                  className="arrow-button"
                  aria-label="Next"
                  data-testid="next-button"
                >
                  <MdOutlineKeyboardArrowRight className="arrow-icon" />
                </button>
              </div>
              <div className="calender-dates">
                <ul className="days-ul">
                  {daysList.map(item => (
                    <li key={item.id} className="days-li">
                      <p className="day-calender-Para">{item.day}</p>
                    </li>
                  ))}
                </ul>
                <ul className="dates-ul">
                  {calenderList[month - 1].dates.map(item => {
                    const {id, date, emojiUrl} = item
                    const onClick = () => {
                      onChangeCalenderList(id, month)
                    }
                    return (
                      <li key={id} className="dates-li">
                        <button
                          type="button"
                          onClick={onClick}
                          className="dates-li-button"
                        >
                          <p className="dates-para">{date}</p>
                          {item.emojiName !== '' ? (
                            <img
                              className="dates-emoji"
                              src={emojiUrl}
                              alt={date}
                            />
                          ) : (
                            ''
                          )}
                        </button>
                      </li>
                    )
                  })}
                </ul>
              </div>
            </>
          )
        }}
      </MoodTrackerContext.Consumer>
    )
  }
}

export default Calendar
